import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { 
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grid,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList
} from '@material-ui/core';

//The following is almost directly taken from Material-UI provided SplitButton example.
//Only minor changes to event handling and text
const useStyles = makeStyles(theme => ({
  dlButton: {
    margin:theme.spacing(2,0,0,0),
    zIndex: 2,
    colorInherit: "#9ecae1"
  }
}));

const { PUBLIC_URL } = process.env;
const ORIGINAL_FILEURL = PUBLIC_URL + '/AllProv_FINAL_(Real2017).xlsx';
const UNCRPD_FILEURL = PUBLIC_URL + '/UNCRPD_Services.xlsx';
const DATA_FILEURL= PUBLIC_URL + '/AllProvinces.csv';

const originalFile = (
  <a className="dlLink" href={ORIGINAL_FILEURL} download={ORIGINAL_FILEURL}>
    Excel Spreadsheet
  </a>
);
const csvFile = (
  <a className="dlLink" href={DATA_FILEURL} download={DATA_FILEURL}>
    CSV from Data
  </a>
);
const uncrpdFile = (
  <a className="dlLink" href={UNCRPD_FILEURL} download={UNCRPD_FILEURL}>
    UNCRPD Table
  </a>
);

const options = [originalFile, csvFile, uncrpdFile];
const urlOptions = [ORIGINAL_FILEURL, DATA_FILEURL, UNCRPD_FILEURL];

export default function DownloadButton() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  function handleMenuItemClick(event, index) {
    setSelectedIndex(index);
    setOpen(false);
  }

  function handleToggle() {
    setOpen(prevOpen => !prevOpen);
  }

  function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }

  return (
    <Grid container className={classes.dlButton}>
      <Grid item xs={12} align="center">
        <ButtonGroup 
          variant="contained" 
          color="inherit" 
          ref={anchorRef} 
          aria-label="split button"
        >
          <Button href={urlOptions[selectedIndex]}>
            {options[selectedIndex]}
          </Button>
          <Button
            color="inherit"
            variant="contained"
            size="small"
            aria-owns={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper 
          open={open} 
          anchorEl={anchorRef.current} 
          transition 
          keepMounted={false}
          disablePortal={true}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 
                  'center bottom',
              }}
            >
              <Paper id="menu-list-grow">
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        selected={index === selectedIndex}
                        onClick={event => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
}